import { Api } from '../typings/api';
import { downloadsFolder } from './index';
import DriveItemUtils from './driveItem';
import NativeApi from './nativeApi';
import UserAgentUtils from './userAgent';
import {
	isOfflineDownloadDebugEnabled,
	logOfflineDownload,
	OfflineDownloadDebugAction,
	OfflineDownloadPhase,
} from './offlineDownloadDebug';

const Q = require('q');

export default class DownloadDiskVerification {

	public static requiresIndexHtmlVerification(driveItem: Api.DriveItem): boolean {
		return driveItem.type === Api.DriveItemType.Publication
			|| driveItem.type === Api.DriveItemType.Gallery;
	}

	public static getDriveItemLocalPath(driveItem: Api.DriveItem): string {
		if (DownloadDiskVerification.requiresIndexHtmlVerification(driveItem)) {
			return `${downloadsFolder}/${driveItem.id}/index.html`;
		}

		switch (driveItem.type) {
			case Api.DriveItemType.Component:
			case Api.DriveItemType.Template:
				return `${downloadsFolder}/${driveItem.id}`;
			case Api.DriveItemType.Image:
			case Api.DriveItemType.Movie:
			case Api.DriveItemType.Sound:
			case Api.DriveItemType.File:
				return `${downloadsFolder}/${DriveItemUtils.getDownloadedFileName(driveItem)}`;
			default:
				return `${downloadsFolder}/${driveItem.id}`;
		}
	}

	// assumeOnDiskOnError: result if the native check errors. true (default) assumes present to avoid
	// needless re-downloads; false assumes missing, used when confirming.
	public static isDriveItemOnDisk(driveItem: Api.DriveItem, assumeOnDiskOnError: boolean = true): Q.Promise<boolean> {
		if (!UserAgentUtils.isMobileApp) {
			return Q.Promise.resolve(true);
		}

		const path = DownloadDiskVerification.getDriveItemLocalPath(driveItem);
		const useDirectory = !DownloadDiskVerification.requiresIndexHtmlVerification(driveItem)
			&& (driveItem.type === Api.DriveItemType.Component
				|| driveItem.type === Api.DriveItemType.Template);

		if (isOfflineDownloadDebugEnabled()) {
			logOfflineDownload(OfflineDownloadDebugAction.DiskCheck, useDirectory ? OfflineDownloadPhase.ExistDirectory : OfflineDownloadPhase.ExistFile, driveItem.id, {
				path,
				itemType: driveItem.type,
			});
		}

		if (useDirectory) {
			return NativeApi.existDirectory(path).catch(() => assumeOnDiskOnError);
		}

		return NativeApi.existFile(path).catch(() => assumeOnDiskOnError);
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/downloadDiskVerification.ts